import type { WithId } from '@medplum/core';
import type { ServiceRequest } from '@medplum/fhirtypes';
import type { TFunction } from 'i18next';

/**
 * Build the display name for a lab order. Lab orders carry one or more test codings
 * on `code.coding`; this picks the most descriptive surface available without falling
 * through to the generic "Unknown" label when any meaningful text exists.
 */
export const getLabOrderName = (sr: WithId<ServiceRequest>, t: TFunction<'records'>): string => {
  const codings = sr.code?.coding ?? [];
  if (codings.length >= 2) {
    const joined = codings
      .map((c) => c.display ?? c.code)
      .filter((text): text is string => Boolean(text))
      .join(', ');
    if (joined) return joined;
  }
  return sr.code?.text ?? codings[0]?.display ?? t('unknownLabOrder');
};
